exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".announcement-author{opacity:.5;font-size:smaller}.announcement-header{font-weight:bold;font-size:17px}.announcement-text{opacity:0.6;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:25ch}\n", ""]);

// exports
